import { Mapper } from "../../../../base/utils/mapper";
import { TestFisicalResponseModel } from "../../../../domain/models/consult/test-fisical.response.model";
import { TestFisicalResponseEntity } from "../entities/test-fisical.response.entity";


export class TestFisicalImplementationRepositoryMapper extends Mapper<TestFisicalResponseEntity, TestFisicalResponseModel> {
    mapFrom(param: TestFisicalResponseEntity): TestFisicalResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TestFisicalResponseModel): TestFisicalResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}